import { useEffect } from "react";

import {
  Box,
  CircularProgress,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { useOutboundNetworkInvites } from "hooks";

import { OutboundInviteRow } from "./components/OutboundInviteRow";
import { EvotruxDivider } from "../../../EvotruxDivider/EvotruxDivider";

interface Props {
  refresh: boolean;
  onRefreshComplete: () => void;
}

export function OutboundInvites(props: Props) {
  const { refresh = false, onRefreshComplete = () => {} } = props;
  const { data, loading, error, refetch } = useOutboundNetworkInvites();

  useEffect(() => {
    if (refresh) {
      refetch();
      if (onRefreshComplete) {
        onRefreshComplete();
      }
    }
  }, [refresh, refetch, onRefreshComplete]);

  if (loading) {
    return (
      <Stack spacing={2}>
        <Typography variant="h5" fontWeight="600">
          Outbound Invites
        </Typography>
        <EvotruxDivider />
        <Stack alignItems="center" py={2}>
          <CircularProgress size={24} />
        </Stack>
      </Stack>
    );
  }

  if (error) {
    return (
      <Stack spacing={2}>
        <Typography variant="h5" fontWeight="600">
          Outbound Invites
        </Typography>
        <EvotruxDivider />
        <Typography color="error">{error}</Typography>
      </Stack>
    );
  }

  return (
    <Stack spacing={2}>
      <Typography variant="h5" fontWeight="600">
        Outbound Invites ({data.length})
      </Typography>
      <EvotruxDivider />
      {data.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No outbound invites sent yet.
        </Typography>
      ) : (
        <Box
          sx={{
            maxHeight: "400px",
            overflowY: "scroll",
          }}
        >
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Contact</TableCell>
                  <TableCell>Company</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Date Sent</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((invite) => (
                  <OutboundInviteRow
                    key={`${invite.invite_target_type}-${invite.invite_id}`}
                    invite={invite}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Stack>
  );
}
